import { render, staticRenderFns } from "./UsersTable.vue?vue&type=template&id=19e6ce24"
import script from "./UsersTable.vue?vue&type=script&lang=ts"
export * from "./UsersTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports